export type PromoApp = {
  id: string
  name: string
  tagline: string
  blurb: string
  cta: string
  url: string
  /** Optional house-ad icon (bundled under /public). */
  iconSrc?: string
  utmContent: string
  enabled: boolean
}

/** Springboard to Navigator — no in-app Mixpanel needed. */
const UTM =
  'utm_source=tabofshame&utm_medium=house_ad&utm_campaign=cross_promo'

export const NAVIGATOR_TEST_DRIVE_DEEP_LINK = 'navigatorofshame://test-drive'
export const NAVIGATOR_WEB_DEMO = 'https://navigatorofshame.com/demo'

export function navigatorFallbackUrl(utmContent: string): string {
  return promoUrl(NAVIGATOR_WEB_DEMO, utmContent)
}

export function tabCardFooterUrl(): string {
  return promoUrl(NAVIGATOR_WEB_DEMO, 'tab_card')
}

export function promoUrl(base: string, utmContent: string): string {
  const joiner = base.includes('?') ? '&' : '?'
  return `${base}${joiner}${UTM}&utm_content=${encodeURIComponent(utmContent)}`
}

/**
 * House ads only — no AdMob, no RevenueCat, no third-party network.
 * Flip `enabled` when a sibling is ready to rotate in.
 */
export const PROMO_APPS: PromoApp[] = [
  {
    id: 'navigator',
    name: 'Navigator of Shame',
    tagline: 'GPS that roasts you for every wrong turn.',
    blurb:
      'Turn-by-turn with an attitude. The flagship Shame Logic app, for when getting there is not the hard part — listening to yourself is.',
    cta: 'Try Navigator of Shame',
    url: promoUrl('https://navigatorofshame.com/marketing', 'top_banner'),
    iconSrc: '/promo/navigator-app-icon.png',
    utmContent: 'top_banner',
    enabled: true,
  },
  {
    id: 'fitness',
    name: 'Shame Fitness',
    tagline: 'Skipped the gym? We noticed.',
    blurb: 'Accountability that talks back. Steps, workouts, and a roast when you flake.',
    cta: 'Get Shame Fitness',
    url: promoUrl('https://apps.apple.com/us/app/shame-fitness/id6785126163', 'fitness_banner'),
    utmContent: 'fitness_banner',
    enabled: false,
  },
  {
    id: 'reader',
    name: 'Shame Reader',
    tagline: 'Point the camera. Hear the page. Catch the attitude.',
    blurb: 'OCR that reads print out loud, then roasts the headline.',
    cta: 'Get Shame Reader',
    url: promoUrl('https://apps.apple.com/us/app/shame-reader/id6788588991', 'reader_banner'),
    utmContent: 'reader_banner',
    enabled: false,
  },
]

export function enabledPromos(): PromoApp[] {
  return PROMO_APPS.filter((app) => app.enabled)
}
